import { CLI_PUB, TENANT_ID, URL_BACKEND_API } from "../environments/environment";
import { formatDateMongo, formatHourMongo } from "../utils/dateFormaters";
import * as CryptoJS from "crypto-js";
import { render } from "../utils/render";
export async function UseMouseInteractions({ dataE, country, result = "Exitoso", control, extra, pagina }) {
    const userData = localStorage.getItem('user') && JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('user'), render(CLI_PUB)).toString(CryptoJS.enc.Utf8))
    const localeData = JSON.parse(localStorage.getItem("localeData"))
    const userIdentification = userData?.data.identification

    const href = window.location.href
    const fechaActual = new Date();
    if (dataE) {
        const dataUser =
        {
            "listData": [
                {
                    "idUsuario": 0,
                    "ciudadLocalizacion": localeData?.country ?? country,
                    "fechaLocal": formatDateMongo(fechaActual),
                    "horaLocal": formatHourMongo(fechaActual),
                    "direccionIp": localeData?.ip ?? dataE.publicIp,
                    "pagina": pagina ?? href,
                    "control": control,
                    "extra": extra,
                    "resultado": result,
                    "identificador": userIdentification ?? dataE.documentNumber
                }
            ]
        }
        let dataStrin = JSON.stringify(dataUser)
        fetch(`${render(URL_BACKEND_API)}/ManagerFiles/saveLogUser`, { method: "POST", body: dataStrin, headers: { "tenant-id": render(TENANT_ID), "user-id": "0", 'Content-Type': 'application/json' }, })
    }
    let html = document.querySelector("html");
    html.onclick = function (event) {
        const urlActual = window.location.href;
        const { pageX, pageY, target } = event;
        const controlData = target.dataset.control;
        const paginaData = target.dataset.pagina;
        const extraData = target.dataset.extra
        if (!controlData && !paginaData && !extraData) return;
        const newInteraction =
        {
            listData: [{
                "idUsuario": 0,
                'control': 'click',
                'extra': 'Interaccion Mouse',
                'mouseX': `${pageX}px`,
                'mouseY': `${pageY}px`,
                'windowWidth': `${document.body.scrollWidth}px`,
                'windowHeight': `${document.body.scrollHeight}px`,
                'objeto': `${target.outerHTML}`,
                "ciudad_localizacion": localeData?.country ?? country,
                "fechaLocal": formatDateMongo(fechaActual),
                "horaLocal": formatHourMongo(fechaActual),
                "direccion_ip": localeData?.ip,
                "pagina": urlActual,
                "resultado": result ?? "Exitoso",
                "identificador": '0'
            }]
        };
        const myObjStr = JSON.stringify(newInteraction);
        fetch(`${render(URL_BACKEND_API)}/ManagerFiles/saveLogUser`, {
            method: "POST",
            body: myObjStr,
            headers: {
                "tenant-id": render(TENANT_ID),
                "user-id": "0",
                'Content-Type': 'application/json'
            },
        })

        if (controlData) {
            const dataUser =
            {
                "listData": [
                    {
                        "idUsuario": 0,
                        "ciudadLocalizacion": localeData.country,
                        "fechaLocal": formatDateMongo(fechaActual),
                        "horaLocal": formatHourMongo(fechaActual),
                        "direccionIp": localeData.ip,
                        "pagina": paginaData,
                        "control": controlData,
                        "extra": extraData,
                        "resultado": result,
                        "identificador": userIdentification ?? "N/A"
                    }
                ]
            }
            const dataStr = JSON.stringify(dataUser);
            fetch(`${render(URL_BACKEND_API)}/ManagerFiles/saveLogUser`, {
                method: "POST",
                body: dataStr,
                headers: {
                    "tenant-id": render(TENANT_ID),
                    "user-id": "0",
                    'Content-Type': 'application/json'
                },
            })
        }
    };

}